/** Reglas de rol operativo (people.operational_role), alineadas con server/api/people_operational_role.php */

export function normalizeOperationalRoleLabel(label) {
  return String(label ?? '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

/** Perfil que puede ser destinatario de asignación/préstamo a persona. */
export function roleAssigns(label) {
  const n = normalizeOperationalRoleLabel(label);
  return n !== '' && n.includes('coordinador');
}

/** Perfil que puede figurar como quien documenta un proyecto. */
export function roleDocuments(label) {
  const n = normalizeOperationalRoleLabel(label);
  return n !== '' && n.includes('brigadista');
}

export function personOperationalRole(person) {
  return String(person?.operationalRole || person?.operational_role || '').trim();
}
